import { useState } from 'react';
import CustomAccordion from '../../../../components/Accordion';
import UserAccordionSummary from './UserAccordionSummary';
import UserAccordionBody from './UserAccordionBody';

const UserAccordion = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);
  const monetized = user.isProduct;
  const isDeleted = user?.deleted;

  return (
    <CustomAccordion
      _id={user.id}
      expanded={isOpen}
      className="user-accordion"
      setExpanded={() => setIsOpen((current) => !current)}
      summary={(
        <UserAccordionSummary
          image={user.image}
          name={!isDeleted ? user.username : 'Deleted User'}
          expiration={monetized ? user.dateExpiring : ''}
          personalVolume={user.personalVolume}
          mgCoins={user.mgCoins}
          isDeleted={isDeleted}
          team={user.sponsorTeam}
        />
      )}
      details={(
        <UserAccordionBody
          name={user.displayName}
          mobile={user.mobile}
          activation={user.dateLastRenewed}
          email={user.email}
          pack={user.package || 'N/A'}
          rank={user.promoBonusActive ? user.promoRankName : user.rankName}
          isDeleted={isDeleted}
        />
      )}
    />
  );
};

export default UserAccordion;
